/** Sentinel value for the "Custom / Other" dropdown option */
export const CUSTOM_QUESTION_TYPE_VALUE = '__custom__';

export const KNOWN_QUESTION_TYPES = [
  { value: 'multiple_choice', label: 'Multiple Choice' },
  { value: 'text_input', label: 'Text Input' },
  { value: 'audio_comprehension', label: 'Audio Comprehension' },
  { value: 'reading_comprehension', label: 'Reading Comprehension' },
  { value: 'listening_comprehension_set', label: 'Listening Comprehension Set' },
  { value: 'reading_comprehension_set', label: 'Reading Comprehension Set' },
] as const;

const KNOWN_TYPE_VALUES = new Set(
  KNOWN_QUESTION_TYPES.map((type) => type.value as string)
);

export const isKnownQuestionType = (type: string): boolean =>
  Boolean(type) && KNOWN_TYPE_VALUES.has(type);

/** Normalize a type for the dropdown: known types as-is, others map to Custom */
export const getQuestionTypeSelection = (type: string): string => {
  if (!type) return '';
  return isKnownQuestionType(type) ? type : CUSTOM_QUESTION_TYPE_VALUE;
};

/** Resolve the type string to save from dropdown + optional custom slug */
export const resolveQuestionType = (
  selection: string,
  customSlug: string
): string => {
  if (selection === CUSTOM_QUESTION_TYPE_VALUE) {
    return customSlug.trim();
  }
  return selection;
};

/** Allow snake_case slugs like opinion_reasoning */
export const isValidCustomQuestionTypeSlug = (slug: string): boolean =>
  /^[a-z][a-z0-9_]*$/.test(slug.trim());
